import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columnName = {
    customerName: 'customer.name',
    deviceSKUName: 'deviceSKU.name',
    deviceName: 'name',
    serialNumber: 'serialNumber',
    rfid: 'rfid',
    contractCode: 'contractCode',
    installationDate: 'installationDate',
};

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: columnName.serialNumber,
        headerName: 'Seri/Mã',
        editable: false,
        sortable: true,
        minWidth: 70,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => <HoverCopyCell value={params.row.serialNumber} />,
    },
    {
        field: columnName.deviceName,
        headerName: 'Tên thiết bị',
        editable: false,
        sortable: false,
        minWidth: 250,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.name}>
                <EntityDetailButton
                    text={params.row.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row.id}
                    type='DEVICE'
                />
            </HoverCopyCell>
        ),
    },
    {
        field: columnName.customerName,
        headerName: 'Khách hàng',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.customer?.name}>
                <EntityDetailButton
                    text={params.row.customer?.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row.customerId}
                    type='CUSTOMER'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.CUSTOMER],
    },
    {
        field: columnName.deviceSKUName,
        headerName: 'SKU thiết bị',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 150,
        renderCell: params => (
            <HoverCopyCell value={params.row.deviceSKU?.name} />
        ),
    },
    {
        field: columnName.rfid,
        headerName: 'Mã RFID',
        editable: false,
        sortable: false,
        minWidth: 100,
        renderCell: params => <HoverCopyCell value={params.row.rfid} />,
    },
    {
        field: columnName.installationDate,
        headerName: 'Ngày lắp đặt',
        editable: false,
        sortable: true,
        minWidth: 120,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell
                value={dateUtils.getDate(params.row.installationDate)}
            />
        ),
    },
];
